import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";

document.getElementById('current-year').innerHTML = new Date().getFullYear()

initScrollReveal(targetElements, defaultProps);
initTiltEffect();
